<template>

	<v-sheet id="dropzone"
				ref="dzone"
				tabindex="0"
				title="Klicka här för att ladda upp en fil!"
				:color="dragover?'red lighten-4':'indigo lighten-4'"
				width="100%"
				style="cursor:pointer;"
				height="200"
				class="dropzone pa-2" :class="{ 'dragover': dragover }">
		<input ref="upload"
				 id="fileUpload"
				 type="file"
				 accept="text/xml"
				 style="display:none" />
		<v-row justify="center" class="pt-5">
			<span class="title indigo--text text--darken-2">Ladda upp en SIE-fil för test genom att släppa den här!</span>
		</v-row>
		<v-row justify="center" class="pt-5">
			<v-icon color="indigo darken-2"
					  size="75">mdi-cloud-upload-outline</v-icon>
		</v-row>

	</v-sheet>
</template>
<script>
	import config from 'config';
	import axios from "axios";
	import * as Sentry from '@sentry/vue';

	export default {
		name: 'FileDrop',
		data() {
			return {
				dragover: false,
				files: []
			}
		},
		mounted() {
			const dropzone = this.$el;
			const fileupload = this.$el.firstElementChild;
			// register listeners on your dropzone / v-sheet
			if (dropzone) {
				// register all drag & drop event listeners
				dropzone.addEventListener("dragenter", e => {
					e.preventDefault()
					this.dragover = true
				})
				dropzone.addEventListener("dragleave", e => {
					e.preventDefault()
					this.dragover = false
				})
				dropzone.addEventListener("dragover", e => {
					e.preventDefault()
					this.dragover = true
				})
				dropzone.addEventListener("drop", e => {
					e.preventDefault()
					const dragevent = e
					this.files = [];
					if (dragevent.dataTransfer) {
						//console.log('drop');
						for (let i = 0; i < e.dataTransfer.files.length; i++) {
							this.files.push(e.dataTransfer.files[i]);
						}
						this.submitFiles(this.files)
					}
					this.dragover = false;
				})
			}
		},
		methods: {
			submitFiles(files) {
				this.$emit("uploading");

				let formData = new FormData();
				formData.append('file', files[0]);

				axios.post(`${config.apiUrl}/upload`,
					formData,
					{
						timeout: 20000,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				).then((response) => {
					this.$emit("uploaded", response.data);
				})
					.catch((error) => {
						Sentry.captureException(error);
						if (error.response) {
							// The request was made and the server responded with a status code
							// that falls out of the range of 2xx

							var msg = 'Request to '+ error.response.config.url + ' failed with status code ' + error.response.status + " - " + error.response.statusText;
							//console.log(msg);
							this.$emit("failed", msg);
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js

							this.$emit("failed", 'No response');
						} else {
							// Something happened in setting up the request that triggered an Error

							this.$emit("failed", error.message);
						}
					});
			},


		}
	};
</script>

<style scoped>
	.dropzone {
		outline: 2px dashed #92b0b3;
		outline-offset: -10px;
		-webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
		transition: outline-offset .15s ease-in-out, background-color .15s linear;
	}

		.dropzone.dragover {
			outline-offset: -20px;
			outline-color: #c8dadf;
			background-color: #fff0f0; /* Light pink */
		}
</style>

